import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ElementRef, OnChanges, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-chart-circle',
  templateUrl: './chart-circle.component.html',
  styleUrls: ['./chart-circle.component.sass']
})
export class ChartCircleComponent implements OnInit, OnChanges, AfterViewInit {

  constructor() {
  }
  @Input() value = 0;
  @Input() name = null;
  @ViewChild('progress') progress: ElementRef;

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.drawCircle();
  }

  ngOnChanges() {
    this.drawCircle();
  }

  drawCircle() {
    if (!this.progress) {
      return;
    }

    const elmt = this.progress.nativeElement;
    const circ = elmt.attributes.r.value * 2 * Math.PI;

    elmt.style['stroke-dasharray']  = circ;
    elmt.style['stroke-dashoffset'] = circ - (circ * this.value) / 100;
  }
}
